<template>

  <div>

    <div class="ui large breadcrumb">
      <div class="bold section">{{ title }}</div>
    </div>

    <bookmark-button :label="title" />

    <div class="ui divider"></div>

    <div class="ui grid">      
      <div class="eleven wide computer sixteen wide tablet sixteen wide mobile column">
        <button class="ui blue button" @click="$router.push('/entries/vets/new')">
          <i class="plus icon"></i> Novo Veterinário
        </button>
      </div>
      <div class="five wide computer sixteen wide tablet sixteen wide mobile column">
        <div class="ui basic right aligned segment no-padding no-margin">
          <div class="ui form">
            <div class="field">
              <search-input id="vets-search-input" ref="searchInput" @onSearch="search" />
            </div>
          </div>    
        </div> 
      </div>
    </div>

    <data-table id="vets-dtbl" ref="dtbl" :service="service" :attributes="attributes" :fields="fields" @onRowClick="navToVetForm" />

  </div>

</template>

<script>
  
  import VetService from "@/services/vet-service"
  import { gridPage, onlySimavet } from "@/mixins"

  export default {    

    name: "VetsPage",

    mixins: [gridPage, onlySimavet],

    data() {
      return {        
        title: "Veterinários",
        service: new VetService(),
        attributes: ["id", "name", "email", "mobile", "phone", "crmv"],
        fields: [          
          { prop: "name", label: "Nome" },        
          { prop: "email", label: "E-mail" },                    
          { prop: "mobile", label: "Celular" },
          { prop: "phone", label: "Telefone" },
          { prop: "crmv", label: "CRMV" },                    
        ],
      }
    },

    methods: {

      navToVetForm(data) {
        this.$router.push("/entries/vets/" + data.row.id)
      },
    },
  }

</script>
